import { render } from "./ContributePermissions.vue?vue&type=template&id=791c40c9&scoped=true"
import script from "./ContributePermissions.vue?vue&type=script&lang=js"
export * from "./ContributePermissions.vue?vue&type=script&lang=js"

import "./ContributePermissions.vue?vue&type=style&index=0&id=791c40c9&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-791c40c9"

export default script